module.exports = __webpack_public_path__ + "static/anagha-b0be316d32d1ba169845ba740dc8efcf.png";